export enum ITolerationEffect {
  "NoSchedule" = "NoSchedule",
  "PreferNoSchedule" = "PreferNoSchedule",
  "NoExecute" = "NoExecute",
}

export enum ITolerationOperator {
  "Equal" = "Equal",
  "Exists" = "Exists",
}

export interface LabelKeyPair {
  key: string;
  value: string;
}

export interface MinIOCredentials {
  accesskey?: string;
  secretkey?: string;
}
